import personApi from '@/api/person.api'

export const personService = (function () {
    'use strict'


    /**
     * Devuelve los datos para la tabla del ABM de personas
     * @param {*} pageSize
     * @param {*} pageNumber
     * @param {*} headers
     * @param {*} enterpriseIds
     */
    async function findAll (pageSize, pageNumber, headers = false, enterpriseIds) {
        try {
            /*
            if (pageSize > 0 && pageNumber > 0) {
                const response = await personApi.findAll(pageSize, pageNumber, headers)
                return response.data
            } else {
                return {
                    data: [],
                    headers: []
                }
            }
            */
            const response = await personApi.findAll(undefined, undefined, headers, enterpriseIds)
            return response.data
        } catch (exception) {
            console.log(exception)
            return {
                data: [],
                headers: []
            }
        }
    }

    /**
     * Devuelve el total de personas de la collection para el paginador de la tabla del ABM
     */
    async function getTotal (enterpriseIds) {
        try {
            const response = await personApi.getTotal(enterpriseIds)
            return response.data
        } catch (exception) {
            console.log(exception)
            return 0
        }
    }

    /**
     * Para eliminar una persona
     */
    async function deleteOne(id) {
        try {
            const response = await personApi.deleteOne(id)
            return response.data
        } catch (exception) {
            console.log(exception)
            return null
        }
    }

    /**
     * Para eliminación múltiple
     */
    async function deleteMany(ids) {
        try {
            const response = await personApi.deleteMany(ids)
            return response.data
        } catch (exception) {
            console.log(exception)
            return null
        }
    }


    /**
     * Crea una persona nueva en la collection
     * @param {*} person 
     * @param {*} personIdDriverCodeUnset 
     */
    async function create(person, personIdDriverCodeUnset) {
        const response = await personApi.create(person, personIdDriverCodeUnset)
        return response.data
    }

    /**
     * Actualiza una persona existente en la collection
     * @param {*} person
     * @param {*} personIdDriverCodeUnset
     */
    async function update(person, personIdDriverCodeUnset) {
        const response = await personApi.update(person, personIdDriverCodeUnset)
        return response.data
    }

    /**
     * Estados civiles para el selector del ABM
     */
    async function getCivilStatus () {
        try {
            const response = await personApi.getCivilStatus()
            return response.data
        } catch (exception) {
            console.log(exception)
            return []
        }
    }

    /**
     * Datos de una persona a partir de su id
     * Este recurso se utiliza en el ABM de personas cuando se abre el diálogo para edición
     * @param {*} id
     */
    async function findOneById (id) {
        try {
            const response = await personApi.findOneById(id)
            return response.data
        } catch (exception) {
            console.log(exception)
            return null
        }
    }

    /**
     * Selector de conductores de scoring
     * @param {*} enterpriseIds
     */
    async function getDriverSelector(enterpriseIds) {
        try {
            let result = await personApi.getDriverSelector(enterpriseIds)
            return result.data
        } catch (e) {
            console.error(e)
            return []
        }
    }

    /**
     * Validar el código de conductor
     * @param {*} driverCode
     * @param {*} id
     */
    async function validateDriverCode(driverCode, id) {
        try {
            if (driverCode) {
                let result = await personApi.validateDriverCode(driverCode, id)
                return result.data
            } else {
                return false
            }
        } catch (e) {
            console.error(e)
            return {
                validation: true,
                person: {
                    _id: null,
                    name: null
                }
            }
        }
    }

    return {
        findAll,
        getTotal,
        deleteOne,
        deleteMany,
        create,
        update,
        getCivilStatus,
        findOneById,
        getDriverSelector,
        validateDriverCode
    }
})()
